import { Typography } from "@mui/material";
import { BaseModuleSubtypeResponse } from "../../../../../../types/actionModule/baseModuleSubtype";
import { PictureUploadSubtypeDataModel } from "../../../../../../types/actionModule/subtypes/pictureUploadModels";
import { useTranslation } from "react-i18next";

interface Props {
    subtype: BaseModuleSubtypeResponse;
    subtypeData: PictureUploadSubtypeDataModel;
}

export default function PictureUploadSubtypeDetails(props: Props) {
    const { t } = useTranslation();

    return <>
        <Typography variant="subtitle1">{t("incentivationPage.pictureUpload.uploadedImage")}</Typography>
        <img
            style={{ maxHeight: "400px", maxWidth: "100%", objectFit: "contain" }}
            src={props.subtypeData.uploadedImageUrl} />
    </>
}
